import { render } from "./IosFrance.vue?vue&type=template&id=588f4a3b&scoped=true"
import script from "./IosFrance.vue?vue&type=script&lang=js"
export * from "./IosFrance.vue?vue&type=script&lang=js"

import "./IosFrance.vue?vue&type=style&index=0&id=588f4a3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588f4a3b"]])

export default __exports__